export const COLUMN_VISIBILITY_KEY = "girinestham.volunteerParticipantsList.columnVisibility";
export const PAGE_SIZE = 50;

export const COLUMN_DEFS = [
  { id: "student_code", label: "Student code", defaultVisible: true, sortable: true },
  { id: "student_name", label: "Student name", defaultVisible: true, sortable: true },
  { id: "student_contact", label: "Contact", defaultVisible: true, sortable: true },
  { id: "student_email", label: "Email", defaultVisible: false, sortable: true },
  { id: "student_gender", label: "Gender", defaultVisible: false, sortable: true },
  { id: "student_date_of_birth", label: "Date of birth", defaultVisible: false, sortable: true },
  { id: "membership_name", label: "Membership", defaultVisible: true, sortable: true },
  { id: "tournament_name", label: "Tournament", defaultVisible: true, sortable: true },
  { id: "tournament_code", label: "Tournament code", defaultVisible: false, sortable: true },
  { id: "tournament_date", label: "Tournament date", defaultVisible: true, sortable: true },
  { id: "tournament_location", label: "Venue", defaultVisible: false, sortable: true },
  { id: "sport_name", label: "Sport", defaultVisible: false, sortable: true },
  { id: "tournament_level_name", label: "Level", defaultVisible: false, sortable: false },
  { id: "participation_fee", label: "Listed fee", defaultVisible: false, sortable: true },
  { id: "tour_registration_date", label: "Registered on", defaultVisible: true, sortable: true },
  {
    id: "registration_verified",
    label: "Tournament registration verified",
    defaultVisible: false,
    sortable: true,
  },
  { id: "certificate_template_name", label: "Certificate template", defaultVisible: true, sortable: true },
  { id: "certificate_status_name", label: "Certificate allowed", defaultVisible: true, sortable: true },
  { id: "registration_created_at", label: "Record created", defaultVisible: false, sortable: false },
  { id: "receipt_no", label: "Receipt no.", defaultVisible: true, sortable: true },
  { id: "payment_date", label: "Payment date", defaultVisible: true, sortable: true },
  { id: "payment_time", label: "Payment time", defaultVisible: false, sortable: false },
  { id: "amount_paid", label: "Amount paid", defaultVisible: true, sortable: true },
  { id: "payment_mode_name", label: "Payment mode", defaultVisible: true, sortable: true },
  { id: "payment_sub_type_name", label: "Payment sub-type", defaultVisible: false, sortable: true },
  { id: "purpose_name", label: "Purpose", defaultVisible: false, sortable: true },
  { id: "transaction_id", label: "Transaction ID", defaultVisible: false, sortable: true },
  {
    id: "payment_verified",
    label: "Payment verified",
    defaultVisible: true,
    sortable: true,
  },
  { id: "payment_proof", label: "Proof on file", defaultVisible: false, sortable: false },
  { id: "payment_remarks", label: "Remarks", defaultVisible: false, sortable: false },
];
